import { Route, Redirect } from "react-router-dom";
import { cookie } from "../@utils";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { connect } from "react-redux";
const AuthRoute = (props) => {
  const location = useLocation();
  console.log('AuthRoute.js',props);
  const { dispatch } = props;
  useEffect(() => {
    let authorization = cookie.get("authorization");
    if (authorization) {
      dispatch({
        type: "auth/login",
        payload: authorization,
      });
    }
  }, [dispatch]);

  if (!props.auth.authorization) {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: {
            ref: location,
          },
        }}
      />
    );
  }
  return <Route {...props} />;
};

export default connect((state) => {
  return {
    auth: state.auth,
  };
})(AuthRoute);
